import { c as _c } from "react/compiler-runtime";
import type { ColumnField } from '../server/types';
function DefaultCellRenderer(t0) {
  const $ = _c(2);
  const {
    value
  } = t0;
  const t1 = String(value);
  let t2;
  if ($[0] !== t1) {
    t2 = <span>{t1}</span>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}
export default DefaultCellRenderer;